import React from "react";
import {useSearchParams} from "react-router-dom";
import i18n from "../services/i18n";


export default function UrlComponent () {
    const [searchParams] = useSearchParams();
    const lang = searchParams.get("lang");
    if(lang && i18n.language !== lang){
        i18n.changeLanguage(lang);
    }
    return null;
}